import { render, staticRenderFns } from "./DiffrenceVPS.vue?vue&type=template&id=340043d4&scoped=true&"
import script from "./DiffrenceVPS.vue?vue&type=script&lang=js&"
export * from "./DiffrenceVPS.vue?vue&type=script&lang=js&"
import style0 from "./DiffrenceVPS.vue?vue&type=style&index=0&id=340043d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340043d4",
  null
  
)

export default component.exports